<template>
    <v-card>
        <v-card-title class="headline">
            <div v-if="edit_member.member_id == undefined">{{ $t('Dialog_Create_Member_Title') }}</div>
            <div v-else>{{ $t('Dialog_Edit_Member_Title') }}</div>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" class="ma-1" text><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-card-text >
            <v-row  v-if="edit_member.member_id == undefined">
            <v-col cols="12" md="9">
                    <v-text-field 
                        v-model="search_field"
                        prepend-icon="search"
                        label="กรอกข้อมูลสมาชิกเพื่อค้นหา (เช่น ชื่อ, เบอร์โทร, เลขบัตรประชาชน)" hint="">
                    </v-text-field>
                </v-col>
                <v-col cols="3" md="1" sm="2" class="flex"><v-btn color="primary" @click="reload">ค้นหา</v-btn></v-col>
            </v-row>
            <v-row class="mt-10">
                
                <v-col cols="12" md="4" v-if="edit_member.member_id == undefined">


                                    {{ $t('last_reload') }} {{last_reload}}
                                    <v-btn tile icon @click="reload"><v-icon>mdi-refresh</v-icon></v-btn>

                <template>
                <v-data-table
                    :headers="[{ text:'',value:'line_logo'},{ text:'line',value:'line_name'},{text:'date',value:'datetime_created'}]"
                    :items="memberregisterlist"
                    :items-per-page="10"
                    @click:row="selectMember"
                    class="elevation-1"
                >
                    <template v-slot:item.line_logo="{ item }">
                        <img :src="item.line_logo" width="48" class="pt-1"/>
                    </template>
                    <template v-slot:item.line_name="{ item }">
                        <div :style="item.member_id==link_val ? 'color:green' : ''">{{ item.line_name }}</div>
                    </template>
                    <template v-slot:item.datetime_created="{ item }">
                        <div :style="item.member_id==link_val ? 'color:green' : ''">{{ item.datetime_created }}</div>
                    </template>

                </v-data-table>
                </template>
                </v-col>
                <v-col cols="12" v-bind:md="edit_member.member_id == undefined ? '8' : '12'" v-bind:style="edit_member.member_id == undefined ? 'border-left: 1px solid grey;' : '' " class="pl-12">
                    <div v-for="item in registerformlist" :key="item.form_tag" align="left">
                        <div class="subtitle-2 mt-n6">
                            <b>{{ $t('form_tag_' + item.form_tag) }}</b>
                            <small v-if="item.is_required==1"> (*{{ $t('form_is_required_yes_short') }})</small>
                        </div>
                        <div v-if="item.value_type_id==1">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        :label="$t('firstname')"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_0'"
                                        @input="(val) => onchange(item.form_id,val,0)"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        :label="$t('middlename')"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_1'"
                                        @input="(val) => onchange(item.form_id,val,1)"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        :label="$t('lastname')"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_2'"
                                        @input="(val) => onchange(item.form_id,val,2)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else-if="item.value_type_id==2">
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-select
                                        :value="1"
                                        :items="[{name:$t('citizenid'),val:1},{name:$t('passport'),val:2}]"
                                        item-text="name"
                                        item-value="val"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_0'"
                                        @input="(val) => onchange(item.form_id,val,0)"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-text-field
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_1'"
                                        @input="(val) => onchange(item.form_id,val,1)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else-if="item.value_type_id==6">
                            <v-row>
                                <v-col cols="12">
                                    <v-select
                                        :value="1"
                                        :items="[
                                            {name:'รถแทรกเตอร์',val:'รถแทรกเตอร์'}
                                            ,{name:'รถเกี่ยวนวดข้าว',val:'รถเกี่ยวนวดข้าว'}
                                            ,{name:'รถขุด',val:'รถขุด'}
                                            ,{name:'รถดำนา',val:'รถดำนา'}
                                        ]"
                                        item-text="name"
                                        item-value="val"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id"
                                        @input="(val) => onchange(item.form_id,val)"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else-if="item.value_type_id==7">
                            <v-row>
                                <v-col cols="3">
                                    <v-select
                                        :items="[
                                            '01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'
                                        ]"
                                        outlined
                                        dense
                                        label="วัน"
                                        :ref="'form_id_' + item.form_id + '_0'"
                                        @input="(val) => onchange(item.form_id,val,0)"
                                    ></v-select>
                                </v-col>
                                <v-col cols="4">
                                    <v-select
                                        :items="[
                                            {name:'มกราคม',val:'01'}
                                            ,{name:'กุมภาพันธ์',val:'02'}
                                            ,{name:'มีนาคม',val:'03'}
                                            ,{name:'เมษายน',val:'04'}
                                            ,{name:'พฤษภาคม',val:'05'}
                                            ,{name:'มิถุนายน',val:'06'}
                                            ,{name:'กรกฎาคม',val:'07'}
                                            ,{name:'สิงหาคม',val:'08'}
                                            ,{name:'กันยายน',val:'09'}
                                            ,{name:'ตุลาคม',val:'10'}
                                            ,{name:'พฤศจิกายน',val:'11'}
                                            ,{name:'ธันวาคม',val:'12'}
                                        ]"
                                        item-text="name"
                                        item-value="val"
                                        label="เดือน"
                                        outlined
                                        dense
                                        :ref="'form_id_' + item.form_id + '_1'"
                                        @input="(val) => onchange(item.form_id,val,1)"
                                    ></v-select>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        outlined
                                        dense
                                        label="ค.ศ."
                                        :ref="'form_id_' + item.form_id + '_2'"
                                        @input="(val) => onchange(item.form_id,val,2)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else>
                            <v-col cols="12" md="11" class="ml-n3">
                                <v-text-field
                                    outlined
                                    dense
                                    :ref="'form_id_' + item.form_id"
                                    @input="(val) => onchange(item.form_id,val)"
                                ></v-text-field>
                            </v-col>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="submit"
                :disabled="!is_ready"
                class="mr-12"
            >
            {{ $t('form_submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
</template>

<script>
import config from '@/../config.js'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
  props: {station_code:[String, Number],edit_member: {type: Object,required: false,default:new Object()},isaddmember: {type: Boolean,required: false,default:false}},
  data: () => ({
    registerformlist: [],
    memberregisterlist : [],
    link_by:3,
    link_val:null,
    form_values:{},
    is_ready:false,
    last_reload:"",
    search_field : ""
  }),
  mounted: function () {
    var que1 = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.station.get_registerform,{station_code:this.station_code})
    .then(response => {
        this.registerformlist = response.data.registerformlist
        this.$store.commit('finishLoading',que1)
    }).catch(error => {
        this.$router.push({name:'Error',params:error}) 
    })

    if(this.edit_member.member_id == undefined){
        this.reload()
    }else{
        this.selectMember(this.edit_member)
    }

  },
  methods:{
      reload(){
        var que = this.$store.commit('addLoading')
        axios
        .post(
            this.search_field.length == 0 ?
            config.api.url.manage.member.get_candidatelist
            : config.api.url.manage.member.search_candidatelist
        ,{station_code:this.station_code,seachtext:this.search_field},{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.$store.commit('finishLoading',que)
            this.memberregisterlist = response.data.candidatelist
            this.memberregisterlist.forEach((o,i,arr)=>{
                var date = new Date(o.datetime_created)
                date.setHours(date.getHours()+7)
                arr[i].datetime_created = date.toISOString().substring(0,10) + ' ' + date.toISOString().substring(11,19)
            })
            var date = new Date()
            date.setHours(date.getHours()+7)
            this.last_reload = date.toISOString().substring(11,19)
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      },
      closeDialog() {
            this.$emit('onclosed');
      },
      onchange(form_id,form_value,index=0) {
        var value_type_id = this.registerformlist.filter(f=>f.form_id==form_id)[0].value_type_id
        if(value_type_id==1 || value_type_id==2 || value_type_id==7){
            var tmp;
            if(this.form_values[form_id]==undefined){
                if(value_type_id==1) tmp = ['','','']
                else if(value_type_id==2) tmp = [1,'']
                else if(value_type_id==7) tmp = ['','','']
            }else{
                if(value_type_id==7)
                    tmp = [
                        this.form_values[form_id].substring(0,2)
                        ,this.form_values[form_id].substring(2,4)
                        //,(parseInt(this.form_values[form_id].substring(4,8)) + 543).toString()
                        ,this.form_values[form_id].substring(4,8)
                    ]
                else{
                    tmp = this.form_values[form_id].split(',')
                }
                
            }
            tmp[index] = form_value
            if(value_type_id==7){
                //tmp[2] = parseInt(tmp[2]) - 543
                this.form_values[form_id] = tmp.join('')
            }
            else this.form_values[form_id] = tmp.join(',')
        }else{
            this.form_values[form_id] = form_value
        }
        this.checkIsReady()

      },
      submit() {
        if(Object.keys(this.form_values).length>0){
            this.form_values['x'] = 'x';
        }
        var que = this.$store.commit('addLoading')
        axios
        .post(this.isaddmember || this.edit_member.member_id == undefined ? config.api.url.manage.member.add_member : config.api.url.manage.member.edit_member 
            ,{ 
                station_code:this.station_code
                ,formvalue:this.form_values
                ,link_by:this.link_by
                ,link_val:this.link_val
            }
            ,{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.reload()
            this.$store.commit('finishLoading',que)
            this.closeDialog()
            this.$emit('onsuccess',response.data);
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      },
      selectMember(item) {
            this.link_val = item.member_id
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.member.get_memberform,{member_id:item.member_id,station_code:this.station_code},{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                Object.keys(response.data).forEach(f => {
                    if(response.data[f].form_value != null){
                        this.form_values[response.data[f].form_id] = response.data[f].form_value
                    }else{
                        var value_type_id = this.registerformlist.filter(r=>r.form_id==response.data[f].form_id)[0].value_type_id
                        if(value_type_id==1) this.form_values[response.data[f].form_id] = ',,'
                        else if(value_type_id==2) this.form_values[response.data[f].form_id] = '1,'
                        else this.form_values[response.data[f].form_id] = ''
                    }
                })
                this.checkIsReady()
            })
      },
      checkIsReady(){
        if(this.link_val==null){
            this.is_ready = false
        }else{
            this.is_ready = this.registerformlist.every(f=>{
                if(!f.is_required){
                    return true;
                }else{
                    if(this.form_values[f.form_id]==undefined){
                        return false
                    }
                    if(f.value_type_id == 1){
                        var tmp = this.form_values[f.form_id].split(',')
                        return tmp[0].length>0 && tmp[2].length>0;
                    }else if(f.value_type_id == 2){
                        return this.form_values[f.form_id].split(',')[1].length>0;
                    }else if(f.value_type_id == 7){
                        return this.form_values[f.form_id].length==8;
                    }else{
                        return this.form_values[f.form_id].length>0;
                    }
                }
            })  
        }
        Object.keys(this.form_values).forEach(form_id => {
            var value_type_id = this.registerformlist.filter(f=>f.form_id==form_id)[0].value_type_id
            setTimeout(()=>{
                if(value_type_id==1){
                    this.$refs['form_id_' + form_id + '_0'][0].value = this.form_values[form_id].split(',')[0]
                    this.$refs['form_id_' + form_id + '_1'][0].value = this.form_values[form_id].split(',')[1]
                    this.$refs['form_id_' + form_id + '_2'][0].value = this.form_values[form_id].split(',')[2]
                }else if(value_type_id==2){
                    this.$refs['form_id_' + form_id + '_0'][0].value = parseInt(this.form_values[form_id].split(',')[0])
                    this.$refs['form_id_' + form_id + '_1'][0].value = this.form_values[form_id].split(',')[1]
                }else if(value_type_id==7){
                    this.$refs['form_id_' + form_id + '_0'][0].value = this.form_values[form_id].substring(0,2)
                    this.$refs['form_id_' + form_id + '_1'][0].value = this.form_values[form_id].substring(2,4)
                    this.$refs['form_id_' + form_id + '_2'][0].value = this.form_values[form_id].substring(4,8)
                }else{
                    this.$refs['form_id_' + form_id][0].value = this.form_values[form_id]
                } 
            },200)
        });
      }

  }
}
</script>